/** Full amount with thousands separators, e.g. "R120,000". */
export function formatCurrencyAmount(currencySymbol: string, value: number): string {
  return `${currencySymbol}${value.toLocaleString()}`;
}

/** Amount per kilometre, e.g. "R0.32/km". */
export function formatCurrencyPerKm(currencySymbol: string, value: number): string {
  return `${formatCurrencyAmount(currencySymbol, value)}/km`;
}
